import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
  HTTP_INTERCEPTORS,
  HttpContextToken
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';

export const SKIP_ERROR_HANDLING = new HttpContextToken<boolean>(() => false);

@Injectable()
export class WorkspaceInterceptor implements HttpInterceptor {
  constructor(private readonly snackBar: MatSnackBar) {}
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const dataModificationMethods = ['POST', 'PUT', 'PATCH', 'DELETE', 'GET'];
    const isDataModification = dataModificationMethods.includes(request.method);
    const isWorkspaceApi = request.url.includes('/workspace');
    if (!isDataModification || !isWorkspaceApi) {
      return next.handle(request);
    }

    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        const shouldHandleError = request.context.get(SKIP_ERROR_HANDLING);
        if (shouldHandleError) {
          return throwError(() => error);
        }
        const isErrorStatus = error.status >= 400 || error.status === 0;

        if (isErrorStatus && request.method !== 'GET') {
          this.snackBar.open('Save failed. Please try again.', 'Dismiss', {
            duration: 5000,
            panelClass: ['error-snackbar']
          });
        } else if (isErrorStatus && request.method === 'GET') {
          this.snackBar.open('Load failed', 'Dismiss', {
            duration: 5000,
            panelClass: ['error-snackbar']
          });
        }
        return throwError(() => error);
      })
    );
  }
}

export const WorkspaceInterceptorProvider = {
  provide: HTTP_INTERCEPTORS,
  useClass: WorkspaceInterceptor,
  multi: true
};
